
import { defineComponent } from 'vue'
import { useContext, computed, ref } from '@nuxtjs/composition-api'
import Modal from '~/components/Modal/Modal.vue'
import HeaderAccount from '~/components/HeaderAccount/HeaderAccount.vue'
import MenuAccount from '~/components/Account/MenuAccount/MenuAccount.vue'
import MenuAccountSideButton from '~/components/Account/MenuAccount/MenuAccountSideButton.vue'
import EmployersTasksForm from '~/components/Page/EmployersTasks/EmployersTasksForm.vue'
import EmployersTaskMissionBanner from '~/components/Page/EmployersTasks/EmployersTaskMissionBanner.vue'
import Footer from '~/components/Footer/Footer.vue'
import { footerSocial, firstFooterMenus, secondFooterMenus, footerBottomMenu } from '~/shared/const/footer'
import { UserModel } from '~/model/User'
import { useDevices } from '~/utils/use-devices'
import BaseYavagroToastWrapper from '~/components/Notifications/BaseYavagroToastWrapper.vue'

export default defineComponent({
  name: 'AccountLayout',
  components: {
    BaseYavagroToastWrapper,
    HeaderAccount,
    MenuAccount,
    MenuAccountSideButton,
    Footer,
    EmployersTasksForm,
    Modal,
    EmployersTaskMissionBanner
  },
  setup() {
    const ctx = useContext()
    const { isDesktop } = useDevices()
    const isShowMenu = ref(false)
    const showEmployersTasksFormModal = ref(false)
    const authorizedUser = computed(() => ctx.$tstore.auth.authorizedUser ?? new UserModel(null))
    const footerMenusFirst = firstFooterMenus || []
    const footerMenusSecond = secondFooterMenus || []
    const footerMenusBottom = footerBottomMenu || []
    const social = footerSocial || []

    const isCompany = computed(() => {
      const authorizedUser = ctx.$tstore.auth.authorizedUser
      return authorizedUser?.roles.has('company') ?? false
    })
    const getCopyrightText = computed(
      () =>
        `© 2000-${new Date().getFullYear()} АО «Россельхозбанк»</br> Генеральная лицензия Банка России № 3349 от 12 августа 2015`
    )

    const openMenu = () => {
      isShowMenu.value = true
      document.body.style.overflow = 'hidden'
    }

    const closeMenu = () => {
      isShowMenu.value = false
      document.body.style.overflow = ''
    }

    const openEmployersTasksFormModal = () => {
      showEmployersTasksFormModal.value = true
    }

    return {
      isCompany,
      isDesktop,
      isShowMenu,
      authorizedUser,
      getCopyrightText,
      footerMenusFirst,
      footerMenusSecond,
      footerMenusBottom,
      social,
      showEmployersTasksFormModal,
      openMenu,
      closeMenu,
      openEmployersTasksFormModal
    }
  }
})
